import classNames from 'classnames';
import type { InteractiveAtomSize } from '../utils/InteractiveAtomProps';

interface MenuItemParams {
  size: InteractiveAtomSize;
  expandable: boolean;
  isOpen: boolean;
  isDisabled?: boolean;
  selected?: boolean;
  className?: string;
}

const baseClassName =
  'flex flex-col gap-xs rounded-lg border border-transparent text-default';

const sizeClassName: {
  [key in InteractiveAtomSize]: string;
} = {
  large: 'text-sm p-sm',
  default: 'text-sm p-sm',
  small: 'text-sm py-xs px-sm',
};

const menuItemStateClassName = {
  hovered: 'hover:bg-state-hover',
  focused: 'focus:outline-none focus:ring focus:!border-transparent',
  disabled: 'text-status-disabled-dark',
  selected: 'bg-status-selected text-status-selected !border-status-selected',
  disabledSelected: 'text-status-disabled-dark !border-status-disabled-dark',
};

export const getMenuItemClassNames = ({
  size,
  isDisabled,
  selected,
  expandable,
  isOpen,
  className = '',
}: MenuItemParams): string => {
  const isSelectable = !expandable;
  const isDisabledSelected = isDisabled && selected && isSelectable;
  const isDisabledOnly = isDisabled && (!selected || (selected && expandable));

  return classNames(
    className,
    baseClassName,
    sizeClassName[size],
    !isOpen && !isDisabled && menuItemStateClassName.hovered,
    !isDisabled && menuItemStateClassName.focused,
    isDisabledOnly && menuItemStateClassName.disabled,
    isSelectable && !isDisabled && selected && menuItemStateClassName.selected,
    isDisabledSelected && menuItemStateClassName.disabledSelected,
  );
};
